import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import {
    MAT_DIALOG_DATA, MatDialogActions, MatDialogContent,
    MatDialogRef, MatDialogTitle,
} from '@angular/material/dialog';
import {MatIcon} from "@angular/material/icon";

@Component({
    selector: 'app-jitsi-meeting-expiry-dialog',
    standalone: true,
    templateUrl: './jitsi-meeting-expiry-dialog.component.html',
    styleUrl: './jitsi-meeting-expiry-dialog.component.scss',
    imports: [
        MatDialogContent,
        MatIcon,
        MatDialogActions,
        MatDialogTitle
    ]
})
export class JitsiMeetingExpiryDialogComponent
    implements OnInit, OnDestroy {

    minutes!: number;
    initalMinutes!: number;
    seconds = 0;
    countdown = '';

    private intervalId!: ReturnType<typeof setInterval>;

    constructor(
        private dialogRef: MatDialogRef<JitsiMeetingExpiryDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { minutes: number }
    ) {}

    ngOnInit(): void {
        this.minutes = this.data.minutes;
        this.initalMinutes = this.data.minutes;
        this.startCountdown(this.minutes);
    }

    private startCountdown(totalMinutes: number): void {
        let totalSeconds = totalMinutes * 60;

        this.updateCountdown(totalSeconds);

        this.intervalId = setInterval(() => {
            totalSeconds--;

            if (totalSeconds < 0) {
                clearInterval(this.intervalId);
                this.dialogRef.close('exit');
                return;
            }

            this.updateCountdown(totalSeconds);
        }, 1000);
    }

    private updateCountdown(totalSeconds: number): void {
        this.minutes = Math.floor(totalSeconds / 60);
        this.seconds = totalSeconds % 60;

        this.countdown =
            `${this.minutes}:${this.seconds.toString().padStart(2, '0')}`;
    }

    onCancel(): void {
        this.dialogRef.close('exit');
    }

    onConfirm(): void {
        this.dialogRef.close('continue');
    }

    ngOnDestroy(): void {
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
    }
}
